import {useEffect} from "react";
import useLocalStorage from "./useLocalStorage";

import "../App.scss";
import "../styles/paginator.scss";

export default function Testing(props) {

  const [theme, setTheme] = useLocalStorage("theme", "dark");
  // const [testObject, setTestObject] = useLocalStorage("testing", {one: "one", two: "two"});
  const [testInt, setTestInt] = useLocalStorage("page_key", 0);
  const [iOperatedHere, setiOperatedHere] = useLocalStorage("iOperatedHere_key", false);

  const [tags, setTags] = useLocalStorage("tags_key", {});
  const [search, setSearch] = useLocalStorage("search_key", null);
  const [currentPage, setCurrentPage] = useLocalStorage("page_key", 0);
  const [hiddenFilters, setHiddenFilters] = useLocalStorage("hidden_filters", []);


  console.log(testInt);

  useEffect(() => {
    console.log(testInt);
  }, [testInt]);


  return (
    <div>
      TESTING things HERE (saved KEY Values)

      <div className="saved_keys">
        HERE we Go!!
        {iOperatedHere ? (
          <h1>It seems I worked here... {testInt}</h1>
        ) : (
          <h1>It seems I did NOT operated here before!...</h1>
        )}
        <p>
          <button onClick={() => theme === "light" ? setTheme("dark") : setTheme("light")}>Toggle theme</button>
        </p>
        <p>
          Set NEW number... <br/>
          <input type="tel"
                 onKeyUp={(event) => {
                   if (!/[0-9]/.test(event.key)) {
                     event.preventDefault();
                   }
                   else {
                     setTestInt(event.key);
                     setiOperatedHere(true);
                   }
                 }}
          />
        </p>


        <button onClick={() => {setTags({}); setSearch(null); setCurrentPage(0); setHiddenFilters([])}}>RESET ALL</button>



      </div>
    </div>
  );

}